import type { AIConfig, AIContext, AIContextSettings } from '@tunasong/ai-lib'

/**
 * Replace one context's settings, preserving everything else on the config.
 *
 * Extracted and exported so the invariant can be tested directly: the form used to
 * rebuild the config as `{ contexts: … }`, which silently dropped every root-level
 * setting. Editing any context field would therefore erase a space's
 * `allowGeneratedMedia` policy — a setting nobody had touched, lost without a
 * warning, in the one place where losing it means generation quietly turns back on.
 */
export const withContextSettings = (config: AIConfig, context: AIContext, settings: AIContextSettings): AIConfig => ({
  ...config,
  contexts: { ...config.contexts, [context]: settings },
})
